import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, tuple_type, bool_type, uint8_type, class_type, int32_type, record_type, option_type, string_type, union_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { toText, printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";
import { tryFind, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { InvoiceeDetails$reflection, CreditScore$reflection } from "../Invoicee/Common.js";
import { BillingInterval$reflection, VatMode$reflection, Distribution$reflection, PaymentMethod$reflection, InvoiceeType$reflection } from "../../DomainTypes.js";
import { CreditCheckDTO$reflection, InvoiceeBatch$reflection, Country$reflection } from "../CustomerContract/Common.js";
import { PeppolId$reflection } from "../../Validation/Invoicee.js";
import { map } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { SaveStatus$reflection, LoadState$2$reflection, GlobalDependencies$reflection } from "../../Global.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";

export class PaymentTermsType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ClientStandard", "InvoiceeSpecific", "InvoiceeFixed"];
    }
}

export function PaymentTermsType$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.PaymentTermsType", [], PaymentTermsType, () => [[], [], []]);
}

export function PaymentTermsType_get_ToString() {
    return (_arg) => ((_arg.tag === 1) ? "InvoiceeSpecific" : ((_arg.tag === 2) ? "InvoiceeFixed" : "ClientStandard"));
}

export function PaymentTermsType_get_FromString() {
    return (_arg) => ((_arg === "ClientStandard") ? (new PaymentTermsType(0)) : ((_arg === "InvoiceeSpecific") ? (new PaymentTermsType(1)) : ((_arg === "InvoiceeFixed") ? (new PaymentTermsType(2)) : toFail(printf("[PaymentTermsType - FromString] Could not parse: %s"))(_arg))));
}

export function PaymentTermsType_GetTranslation_11D407F6(getTranslation) {
    return (_arg) => ((_arg.tag === 1) ? getTranslation("CustomerContract.Invoicee.PaymentTerms.InvoiceeSpecific") : ((_arg.tag === 2) ? getTranslation("CustomerContract.Invoicee.PaymentTerms.InvoiceeFixed") : getTranslation("CustomerContract.Invoicee.PaymentTerms.ClientStandard")));
}

export function PaymentTermsType_GetSelectOptions(getTranslation, clientNetDays) {
    let arg;
    return ofArray([[PaymentTermsType_get_ToString()(new PaymentTermsType(0)), (arg = PaymentTermsType_GetTranslation_11D407F6(getTranslation)(new PaymentTermsType(0)), toText(printf("%s (%i)"))(arg)(clientNetDays))], [PaymentTermsType_get_ToString()(new PaymentTermsType(1)), PaymentTermsType_GetTranslation_11D407F6(getTranslation)(new PaymentTermsType(1))], [PaymentTermsType_get_ToString()(new PaymentTermsType(2)), PaymentTermsType_GetTranslation_11D407F6(getTranslation)(new PaymentTermsType(2))]]);
}

export function PaymentTermsType_GetCurrentPaymentTermsType(clientNetDays, invoiceeNetDays, invoiceeFixedDay) {
    const matchValue = [invoiceeFixedDay, invoiceeNetDays, clientNetDays];
    if (matchValue[0] != null) {
        return [new PaymentTermsType(2), invoiceeFixedDay];
    }
    else if (matchValue[1] != null) {
        return [new PaymentTermsType(1), invoiceeNetDays];
    }
    else {
        return [new PaymentTermsType(0), clientNetDays];
    }
}

export class Guarantor extends Record {
    constructor(GuarantorCountryCode, GuarantorOrganizationNr, CreditScore) {
        super();
        this.GuarantorCountryCode = GuarantorCountryCode;
        this.GuarantorOrganizationNr = GuarantorOrganizationNr;
        this.CreditScore = CreditScore;
    }
}

export function Guarantor$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.Guarantor", [], Guarantor, () => [["GuarantorCountryCode", string_type], ["GuarantorOrganizationNr", string_type], ["CreditScore", option_type(CreditScore$reflection())]]);
}

export class AdjustFee extends Record {
    constructor(FeeNr, StartDate, CancelledDate, EndDate, BilledTo, Description, MonthsInAdvance, Fee) {
        super();
        this.FeeNr = (FeeNr | 0);
        this.StartDate = StartDate;
        this.CancelledDate = CancelledDate;
        this.EndDate = EndDate;
        this.BilledTo = BilledTo;
        this.Description = Description;
        this.MonthsInAdvance = MonthsInAdvance;
        this.Fee = Fee;
    }
}

export function AdjustFee$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.AdjustFee", [], AdjustFee, () => [["FeeNr", int32_type], ["StartDate", class_type("System.DateTime")], ["CancelledDate", option_type(class_type("System.DateTime"))], ["EndDate", option_type(class_type("System.DateTime"))], ["BilledTo", option_type(class_type("System.DateTime"))], ["Description", string_type], ["MonthsInAdvance", uint8_type], ["Fee", class_type("System.Decimal")]]);
}

export class EditGeneralTableEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeName", "OnChangeInvoiceType", "OnChangeOrganizationNr", "OnChangeCountry", "OnChangeClientCrossRef", "OnChangeCustomerGroupCode", "EditGeneralTable", "SaveGeneralTable", "CancelGeneralTable"];
    }
}

export function EditGeneralTableEvent$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.EditGeneralTableEvent", [], EditGeneralTableEvent, () => [[["Item", string_type]], [["Item", InvoiceeType$reflection()]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], []]);
}

export class EditAddressTableEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangePostalAddress", "OnChangePostalAttention", "OnChangePostalCode", "OnChangePostalCity", "OnChangePostalCountry", "EditAddressTable", "SaveAddressTable", "CancelAddressTable"];
    }
}

export function EditAddressTableEvent$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.EditAddressTableEvent", [], EditAddressTableEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], []]);
}

export class EditContactTableEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangeEmail", "OnChangeContactPhoneNr", "OnChangeContactPerson", "EditContactTable", "SaveContactTable", "CancelContactTable"];
    }
}

export function EditContactTableEvent$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.EditContactTableEvent", [], EditContactTableEvent, () => [[["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], []]);
}

export class EditInvoiceTableEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OnChangePaymentMethod", "OnChangeDistributionCode", "OnChangePeppolId", "OnChangeVatMode", "OnChangeNoNextInvoice", "OnChangeBillingInterval", "OnChangeHasInvoiceFee", "OnChangeCustomPaymentSlip", "OnChangeClientContactReference", "OnChangeManualDistributionChannel", "OnChangePaymentTermsType", "OnChangeBilledTo", "OnChangeDirectDebitDistribute", "OnChangeEmailAddressInvoice", "OnChangeInvoiceeBatch", "OnChangeOurReference", "OnChangeEInvoiceIdentifier", "EditInvoiceTable", "SaveInvoiceTable", "CancelInvoiceTable"];
    }
}

export function EditInvoiceTableEvent$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.EditInvoiceTableEvent", [], EditInvoiceTableEvent, () => [[["Item", PaymentMethod$reflection()]], [["Item", Distribution$reflection()]], [["Item", string_type]], [["Item", VatMode$reflection()]], [["Item", string_type]], [["Item", BillingInterval$reflection()]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", bool_type]], [["Item1", PaymentTermsType$reflection()], ["Item2", option_type(int32_type)]], [["Item", option_type(class_type("System.DateOnly"))]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], []]);
}

export class GeneralTableViewModel extends Record {
    constructor(Name, OrgNr, CreditScore, Country, InvoiceeType, ClientCrossRef, CustomerGroupCode) {
        super();
        this.Name = Name;
        this.OrgNr = OrgNr;
        this.CreditScore = CreditScore;
        this.Country = Country;
        this.InvoiceeType = InvoiceeType;
        this.ClientCrossRef = ClientCrossRef;
        this.CustomerGroupCode = CustomerGroupCode;
    }
}

export function GeneralTableViewModel$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.GeneralTableViewModel", [], GeneralTableViewModel, () => [["Name", string_type], ["OrgNr", string_type], ["CreditScore", option_type(CreditScore$reflection())], ["Country", option_type(Country$reflection())], ["InvoiceeType", InvoiceeType$reflection()], ["ClientCrossRef", string_type], ["CustomerGroupCode", string_type]]);
}

export class AddressTableViewModel extends Record {
    constructor(PostalAddress, PostalAttention, PostalCode, PostalCity, PostalCountryCode) {
        super();
        this.PostalAddress = PostalAddress;
        this.PostalAttention = PostalAttention;
        this.PostalCode = PostalCode;
        this.PostalCity = PostalCity;
        this.PostalCountryCode = PostalCountryCode;
    }
}

export function AddressTableViewModel$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.AddressTableViewModel", [], AddressTableViewModel, () => [["PostalAddress", string_type], ["PostalAttention", string_type], ["PostalCode", string_type], ["PostalCity", string_type], ["PostalCountryCode", string_type]]);
}

export class ContactTableViewModel extends Record {
    constructor(Email, ContactPhoneNr, ContactPerson) {
        super();
        this.Email = Email;
        this.ContactPhoneNr = ContactPhoneNr;
        this.ContactPerson = ContactPerson;
    }
}

export function ContactTableViewModel$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.ContactTableViewModel", [], ContactTableViewModel, () => [["Email", string_type], ["ContactPhoneNr", string_type], ["ContactPerson", string_type]]);
}

export class InvoiceTableViewModel extends Record {
    constructor(DistributionCode, PeppolId, VatMode, NoNextInvoice, BillingInterval, PaymentDays, DirectDebit, DirectDebitDistribute, ClientContactReference, BilledTo, HasInvoiceFee, CustomPaymentSlip, ManualDistributionChannel, EmailAddressInvoice, PaymentMethod, InvoiceeBatchId, OurReference, PaymentTermsFixedDay, EInvoiceIdentifier, CurrencyCode) {
        super();
        this.DistributionCode = DistributionCode;
        this.PeppolId = PeppolId;
        this.VatMode = VatMode;
        this.NoNextInvoice = NoNextInvoice;
        this.BillingInterval = BillingInterval;
        this.PaymentDays = PaymentDays;
        this.DirectDebit = DirectDebit;
        this.DirectDebitDistribute = DirectDebitDistribute;
        this.ClientContactReference = ClientContactReference;
        this.BilledTo = BilledTo;
        this.HasInvoiceFee = HasInvoiceFee;
        this.CustomPaymentSlip = CustomPaymentSlip;
        this.ManualDistributionChannel = ManualDistributionChannel;
        this.EmailAddressInvoice = EmailAddressInvoice;
        this.PaymentMethod = PaymentMethod;
        this.InvoiceeBatchId = InvoiceeBatchId;
        this.OurReference = OurReference;
        this.PaymentTermsFixedDay = PaymentTermsFixedDay;
        this.EInvoiceIdentifier = EInvoiceIdentifier;
        this.CurrencyCode = CurrencyCode;
    }
}

export function InvoiceTableViewModel$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.InvoiceTableViewModel", [], InvoiceTableViewModel, () => [["DistributionCode", Distribution$reflection()], ["PeppolId", string_type], ["VatMode", VatMode$reflection()], ["NoNextInvoice", bool_type], ["BillingInterval", BillingInterval$reflection()], ["PaymentDays", tuple_type(PaymentTermsType$reflection(), option_type(int32_type))], ["DirectDebit", bool_type], ["DirectDebitDistribute", bool_type], ["ClientContactReference", string_type], ["BilledTo", option_type(class_type("System.DateOnly"))], ["HasInvoiceFee", bool_type], ["CustomPaymentSlip", bool_type], ["ManualDistributionChannel", bool_type], ["EmailAddressInvoice", string_type], ["PaymentMethod", PaymentMethod$reflection()], ["InvoiceeBatchId", option_type(InvoiceeBatch$reflection())], ["OurReference", option_type(string_type)], ["PaymentTermsFixedDay", string_type], ["EInvoiceIdentifier", option_type(string_type)], ["CurrencyCode", option_type(string_type)]]);
}

export class InvoiceeOrgNrOrCountryDTO extends Record {
    constructor(OrgNr, Country) {
        super();
        this.OrgNr = OrgNr;
        this.Country = Country;
    }
}

export function InvoiceeOrgNrOrCountryDTO$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.InvoiceeOrgNrOrCountryDTO", [], InvoiceeOrgNrOrCountryDTO, () => [["OrgNr", string_type], ["Country", string_type]]);
}

export class FeeAdjustDTO extends Record {
    constructor(BillingInterval) {
        super();
        this.BillingInterval = BillingInterval;
    }
}

export function FeeAdjustDTO$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.FeeAdjustDTO", [], FeeAdjustDTO, () => [["BillingInterval", string_type]]);
}

export class UpdateInvoiceeDetailsDTO extends Record {
    constructor(ClientContactReference, ClientCrossRef, ContactPhoneNumber, ContactReference, CreateFeeTemplates, CustomerGroupCode, CustomPaymentSlip, DistributionCode, ExcludeInvoiceFee, Email, ExclVat, InvoiceLanguageCode, InvoiceeType, MonthlyBillingInterval, Name, NoNextInvoice, PaymentTermsNetDays, PeppolId, PostalAddress, PostalAttention, PostalCity, PostalCode, PostalCountryCode, DirectDebitDistribute, ManualDistributionChannel, EmailAddressInvoice, PaymentMethod, InvoiceeBatchId, OurReference, PaymentTermsFixedDay, EInvoiceIdentifier) {
        super();
        this.ClientContactReference = ClientContactReference;
        this.ClientCrossRef = ClientCrossRef;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.ContactReference = ContactReference;
        this.CreateFeeTemplates = CreateFeeTemplates;
        this.CustomerGroupCode = CustomerGroupCode;
        this.CustomPaymentSlip = CustomPaymentSlip;
        this.DistributionCode = DistributionCode;
        this.ExcludeInvoiceFee = ExcludeInvoiceFee;
        this.Email = Email;
        this.ExclVat = ExclVat;
        this.InvoiceLanguageCode = InvoiceLanguageCode;
        this.InvoiceeType = InvoiceeType;
        this.MonthlyBillingInterval = MonthlyBillingInterval;
        this.Name = Name;
        this.NoNextInvoice = NoNextInvoice;
        this.PaymentTermsNetDays = PaymentTermsNetDays;
        this.PeppolId = PeppolId;
        this.PostalAddress = PostalAddress;
        this.PostalAttention = PostalAttention;
        this.PostalCity = PostalCity;
        this.PostalCode = PostalCode;
        this.PostalCountryCode = PostalCountryCode;
        this.DirectDebitDistribute = DirectDebitDistribute;
        this.ManualDistributionChannel = ManualDistributionChannel;
        this.EmailAddressInvoice = EmailAddressInvoice;
        this.PaymentMethod = PaymentMethod;
        this.InvoiceeBatchId = InvoiceeBatchId;
        this.OurReference = OurReference;
        this.PaymentTermsFixedDay = PaymentTermsFixedDay;
        this.EInvoiceIdentifier = EInvoiceIdentifier;
    }
}

export function UpdateInvoiceeDetailsDTO$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.UpdateInvoiceeDetailsDTO", [], UpdateInvoiceeDetailsDTO, () => [["ClientContactReference", option_type(string_type)], ["ClientCrossRef", option_type(string_type)], ["ContactPhoneNumber", option_type(string_type)], ["ContactReference", option_type(string_type)], ["CreateFeeTemplates", option_type(bool_type)], ["CustomerGroupCode", option_type(int32_type)], ["CustomPaymentSlip", option_type(bool_type)], ["DistributionCode", option_type(int32_type)], ["ExcludeInvoiceFee", bool_type], ["Email", option_type(string_type)], ["ExclVat", bool_type], ["InvoiceLanguageCode", option_type(string_type)], ["InvoiceeType", option_type(string_type)], ["MonthlyBillingInterval", option_type(int32_type)], ["Name", option_type(string_type)], ["NoNextInvoice", option_type(bool_type)], ["PaymentTermsNetDays", option_type(int32_type)], ["PeppolId", option_type(string_type)], ["PostalAddress", option_type(string_type)], ["PostalAttention", option_type(string_type)], ["PostalCity", option_type(string_type)], ["PostalCode", option_type(string_type)], ["PostalCountryCode", option_type(string_type)], ["DirectDebitDistribute", option_type(bool_type)], ["ManualDistributionChannel", option_type(bool_type)], ["EmailAddressInvoice", option_type(string_type)], ["PaymentMethod", option_type(string_type)], ["InvoiceeBatchId", option_type(int32_type)], ["OurReference", option_type(string_type)], ["PaymentTermsFixedDay", option_type(int32_type)], ["EInvoiceIdentifier", option_type(string_type)]]);
}

export class ValidDetails extends Record {
    constructor(ClientContactReference, ClientCrossRef, ContactPhoneNumber, ContactReference, CreateFeeTemplates, CustomPaymentSlip, DistributionCode, ExcludeInvoiceFee, Email, ExclVat, InvoiceLanguageCode, InvoiceeType, MonthlyBillingInterval, Name, NoNextInvoice, PaymentTermsNetDays, PeppolId, PostalAddress, PostalAttention, PostalCity, PostalCode, PostalCountryCode) {
        super();
        this.ClientContactReference = ClientContactReference;
        this.ClientCrossRef = ClientCrossRef;
        this.ContactPhoneNumber = ContactPhoneNumber;
        this.ContactReference = ContactReference;
        this.CreateFeeTemplates = CreateFeeTemplates;
        this.CustomPaymentSlip = CustomPaymentSlip;
        this.DistributionCode = DistributionCode;
        this.ExcludeInvoiceFee = ExcludeInvoiceFee;
        this.Email = Email;
        this.ExclVat = ExclVat;
        this.InvoiceLanguageCode = InvoiceLanguageCode;
        this.InvoiceeType = InvoiceeType;
        this.MonthlyBillingInterval = MonthlyBillingInterval;
        this.Name = Name;
        this.NoNextInvoice = NoNextInvoice;
        this.PaymentTermsNetDays = PaymentTermsNetDays;
        this.PeppolId = PeppolId;
        this.PostalAddress = PostalAddress;
        this.PostalAttention = PostalAttention;
        this.PostalCity = PostalCity;
        this.PostalCode = PostalCode;
        this.PostalCountryCode = PostalCountryCode;
    }
}

export function ValidDetails$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.ValidDetails", [], ValidDetails, () => [["ClientContactReference", option_type(string_type)], ["ClientCrossRef", option_type(string_type)], ["ContactPhoneNumber", option_type(string_type)], ["ContactReference", option_type(string_type)], ["CreateFeeTemplates", option_type(bool_type)], ["CustomPaymentSlip", option_type(bool_type)], ["DistributionCode", option_type(int32_type)], ["ExcludeInvoiceFee", bool_type], ["Email", option_type(string_type)], ["ExclVat", bool_type], ["InvoiceLanguageCode", option_type(string_type)], ["InvoiceeType", option_type(string_type)], ["MonthlyBillingInterval", option_type(int32_type)], ["Name", option_type(string_type)], ["NoNextInvoice", option_type(bool_type)], ["PaymentTermsNetDays", option_type(int32_type)], ["PeppolId", PeppolId$reflection()], ["PostalAddress", option_type(string_type)], ["PostalAttention", option_type(string_type)], ["PostalCity", option_type(string_type)], ["PostalCode", option_type(string_type)], ["PostalCountryCode", option_type(string_type)]]);
}

export function getCountryName(countries, code) {
    return map((country_1) => country_1, tryFind((country) => (country.Code.ThreeLetter === code), countries));
}

export function getCountryCode(countries, countryName) {
    return map((country_1) => country_1.Code, tryFind((country) => (country.DisplayName === countryName), countries));
}

export function paymentTermsToString(getTranslation, _arg) {
    if (_arg == null) {
        return "";
    }
    else {
        const paymentTerms = _arg | 0;
        const arg_1 = getTranslation("CustomerContract.Invoicee.Days");
        return toText(printf("%i %s"))(paymentTerms)(arg_1);
    }
}

export function paymentTermsFixedToString(_arg) {
    if (_arg == null) {
        return "";
    }
    else {
        const paymentTermsFixed = _arg | 0;
        return toText(printf("%i"))(paymentTermsFixed);
    }
}

export function getInvoiceeBatch(invoiceeBatches, id) {
    return map((invoiceeBatch_1) => invoiceeBatch_1, tryFind((invoiceeBatch) => (invoiceeBatch.InvoiceeBatchId === id), invoiceeBatches));
}

export class ClientCustomerGroup extends Record {
    constructor(CustomerGroupCode, CustomerGroupName) {
        super();
        this.CustomerGroupCode = (CustomerGroupCode | 0);
        this.CustomerGroupName = CustomerGroupName;
    }
}

export function ClientCustomerGroup$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.ClientCustomerGroup", [], ClientCustomerGroup, () => [["CustomerGroupCode", int32_type], ["CustomerGroupName", string_type]]);
}

export class Modal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "FeeAdjustConfirmation"];
    }
}

export function Modal$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.Modal", [], Modal, () => [[], []]);
}

export class TableViewModel extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["GeneralTableViewModel", "AddressTableViewModel", "ContactTableViewModel", "InvoiceTableViewModel"];
    }
}

export function TableViewModel$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.TableViewModel", [], TableViewModel, () => [[["Item", GeneralTableViewModel$reflection()]], [["Item", AddressTableViewModel$reflection()]], [["Item", ContactTableViewModel$reflection()]], [["Item", InvoiceTableViewModel$reflection()]]]);
}

export class Model extends Record {
    constructor(GlobalDependencies, InvoiceeDetails, ErrorMessage, IsEditingGeneralTable, IsEditingAddressTable, IsEditingContactTable, IsEditingInvoiceTable, IsMonthlyBillingIntervalChanged, GeneralTableViewModel, AddressTableViewModel, ContactTableViewModel, InvoiceTableViewModel, Countries, SaveDetailsButtonDisabled, OpenModal, AdjustFees, IsEditingOrgnr, IsOrgnrOrCountryCodeChanged, CustomerGroupCodes, Guarantor, CreditChecks, InvoiceeDetailsSaveStatus, InvoiceeBatches) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.InvoiceeDetails = InvoiceeDetails;
        this.ErrorMessage = ErrorMessage;
        this.IsEditingGeneralTable = IsEditingGeneralTable;
        this.IsEditingAddressTable = IsEditingAddressTable;
        this.IsEditingContactTable = IsEditingContactTable;
        this.IsEditingInvoiceTable = IsEditingInvoiceTable;
        this.IsMonthlyBillingIntervalChanged = IsMonthlyBillingIntervalChanged;
        this.GeneralTableViewModel = GeneralTableViewModel;
        this.AddressTableViewModel = AddressTableViewModel;
        this.ContactTableViewModel = ContactTableViewModel;
        this.InvoiceTableViewModel = InvoiceTableViewModel;
        this.Countries = Countries;
        this.SaveDetailsButtonDisabled = SaveDetailsButtonDisabled;
        this.OpenModal = OpenModal;
        this.AdjustFees = AdjustFees;
        this.IsEditingOrgnr = IsEditingOrgnr;
        this.IsOrgnrOrCountryCodeChanged = IsOrgnrOrCountryCodeChanged;
        this.CustomerGroupCodes = CustomerGroupCodes;
        this.Guarantor = Guarantor;
        this.CreditChecks = CreditChecks;
        this.InvoiceeDetailsSaveStatus = InvoiceeDetailsSaveStatus;
        this.InvoiceeBatches = InvoiceeBatches;
    }
}

export function Model$reflection() {
    return record_type("Containers.InvoiceeDetails.Model.Model", [], Model, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["InvoiceeDetails", InvoiceeDetails$reflection()], ["ErrorMessage", option_type(string_type)], ["IsEditingGeneralTable", bool_type], ["IsEditingAddressTable", bool_type], ["IsEditingContactTable", bool_type], ["IsEditingInvoiceTable", bool_type], ["IsMonthlyBillingIntervalChanged", bool_type], ["GeneralTableViewModel", GeneralTableViewModel$reflection()], ["AddressTableViewModel", AddressTableViewModel$reflection()], ["ContactTableViewModel", ContactTableViewModel$reflection()], ["InvoiceTableViewModel", InvoiceTableViewModel$reflection()], ["Countries", list_type(Country$reflection())], ["SaveDetailsButtonDisabled", bool_type], ["OpenModal", Modal$reflection()], ["AdjustFees", list_type(AdjustFee$reflection())], ["IsEditingOrgnr", bool_type], ["IsOrgnrOrCountryCodeChanged", bool_type], ["CustomerGroupCodes", LoadState$2$reflection(list_type(ClientCustomerGroup$reflection()), string_type)], ["Guarantor", LoadState$2$reflection(Guarantor$reflection(), string_type)], ["CreditChecks", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, LoadState$2$reflection(CreditCheckDTO$reflection(), string_type)])], ["InvoiceeDetailsSaveStatus", SaveStatus$reflection()], ["InvoiceeBatches", list_type(InvoiceeBatch$reflection())]]);
}

export class InvoiceeDetailsMsg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["LoadedInvoiceeDetails", "LoadHistoricCreditScore", "LoadedHistoricCreditScore", "EditGeneralTableEvent", "EditAddressTableEvent", "EditContactTableEvent", "EditInvoiceTableEvent", "SavedInvoiceeDetails", "LoadedCountries", "LoadInvoiceeBatches", "LoadedInvoiceeBatches", "OpenModal", "CloseModal", "UpdateFeeAdjust", "UpdatedFeeAdjust", "LoadedAdjustFee", "EditOrgnr", "UpdatedInvoiceeOrgNrOrCountry", "ValidatedUpdatedOrgNrOrCountry", "LoadCustomerGroupCodes", "LoadedCustomerGroupCodes", "SavedBilledTo", "LoadGuarantor", "LoadedGuarantor", "SaveGuarantor", "SavedGuarantor", "LoadCreditCheck", "LoadedCreditCheck"];
    }
}

export function InvoiceeDetailsMsg$reflection() {
    return union_type("Containers.InvoiceeDetails.Model.InvoiceeDetailsMsg", [], InvoiceeDetailsMsg, () => [[["Item", InvoiceeDetails$reflection()]], [["Item1", int32_type], ["Item2", InvoiceeDetails$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [option_type(CreditScore$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", option_type(CreditScore$reflection())]], [["ErrorValue", string_type]]])]], [["Item", EditGeneralTableEvent$reflection()]], [["Item", EditAddressTableEvent$reflection()]], [["Item", EditContactTableEvent$reflection()]], [["Item", EditInvoiceTableEvent$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Country$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(Country$reflection())]], [["ErrorValue", string_type]]])]], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(InvoiceeBatch$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(InvoiceeBatch$reflection())]], [["ErrorValue", string_type]]])]], [["Item", Modal$reflection()]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(AdjustFee$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(AdjustFee$reflection())]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, string_type], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(int32_type), string_type], FSharpResult$2, () => [[["ResultValue", list_type(int32_type)]], [["ErrorValue", string_type]]])]], [["Item", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(ClientCustomerGroup$reflection()), string_type], FSharpResult$2, () => [[["ResultValue", list_type(ClientCustomerGroup$reflection())]], [["ErrorValue", string_type]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Guarantor$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", Guarantor$reflection()]], [["ErrorValue", string_type]]])]], [["Item1", string_type], ["Item2", string_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [int32_type, string_type], FSharpResult$2, () => [[["ResultValue", int32_type]], [["ErrorValue", string_type]]])]], [["Item1", int32_type], ["Item2", string_type], ["Item3", string_type]], [["Item1", string_type], ["Item2", union_type("Microsoft.FSharp.Core.FSharpResult`2", [CreditCheckDTO$reflection(), string_type], FSharpResult$2, () => [[["ResultValue", CreditCheckDTO$reflection()]], [["ErrorValue", string_type]]])]]]);
}

